import script from "./DelegateAgreements.vue?vue&type=script&setup=true&lang=js"
export * from "./DelegateAgreements.vue?vue&type=script&setup=true&lang=js"

import "./DelegateAgreements.vue?vue&type=style&index=0&id=7f99f6a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f99f6a8"]])

export default __exports__